export default __webpack_public_path__ + "static/media/icons-deleteAccount.a590fb4c.svg";